/**
 * Injection de la seconde image de la carte produit, au premier survol seulement.
 *
 * Le design system impose que la seconde image ne soit jamais dans le HTML
 * initial : sur une grille de 24 produits, ce sont 24 images téléchargées pour
 * un survol qui n'aura peut-être jamais lieu.
 *
 * L'image est créée une seule fois, puis le fondu est purement CSS.
 * Sur mobile il n'y a pas de survol : rien ne se déclenche, donc rien ne pèse.
 */
class GorringCard extends HTMLElement {
  #loaded = false;

  connectedCallback() {
    if (!this.dataset.hoverSrc) return;
    // `once` : l'écouteur se retire de lui-même après le premier survol.
    this.addEventListener('pointerenter', this.#load, { once: true });
    this.addEventListener('focusin', this.#load, { once: true });
  }

  #load = () => {
    if (this.#loaded) return;
    this.#loaded = true;

    const media = this.querySelector('.g-card__media');
    if (!media) return;

    const img = document.createElement('img');
    img.className = 'g-card__image g-card__image--hover';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.src = this.dataset.hoverSrc;
    img.addEventListener('load', () => this.setAttribute('hover-ready', ''), { once: true });
    media.appendChild(img);
  };
}

if (!customElements.get('gorring-card')) {
  customElements.define('gorring-card', GorringCard);
}
